export default __webpack_public_path__ + "static/media/display_pastel.84bc6ab0.png";